import { render, staticRenderFns } from "./PointsCard.vue?vue&type=template&id=5f304d9e&scoped=true&"
import script from "./PointsCard.vue?vue&type=script&lang=js&"
export * from "./PointsCard.vue?vue&type=script&lang=js&"
import style0 from "./PointsCard.vue?vue&type=style&index=0&id=5f304d9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f304d9e",
  null
  
)

export default component.exports